// extracted by mini-css-extract-plugin
export default {"bannerContainer":"qdMHF5rxi5xedfev6W6m"};